import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ProgressIndicator } from '@eb/eds-progress-indicator';
import { trackAnalyticsEvent } from '@eb/site-analytics';
import RatingStars from '../../containers/ConnectedRatingStars';
import { gettext } from '@eb/i18n';
import {
    APP_RATING_CREATED,
    APP_RATING_UPDATED,
    APP_REVIEW_EVENT_CATEGORY,
} from '../../constants/analytics';
import './OneClickRatingCTA.scss';

export default class OneClickRatingCTA extends PureComponent {
    static propTypes = {
        appId: PropTypes.string.isRequired,
        appName: PropTypes.string.isRequired,
        createNewReview: PropTypes.func.isRequired,
        editReview: PropTypes.func.isRequired,
        hasReview: PropTypes.bool.isRequired,

        currentReviewId: PropTypes.string,
        currentRating: PropTypes.number,
        onAddReviewBtnClick: PropTypes.func,
        onLoad: PropTypes.func,
    };

    constructor() {
        super();

        this.state = {
            isLoading: false,
        };
    }

    componentDidMount() {
        const { onLoad } = this.props;

        if (onLoad) {
            this.setState({ isLoading: true });
            onLoad().finally(() => this.setState({ isLoading: false }));
        }
    }

    _handleStarClick(starRating) {
        const {
            appId,
            appName,
            createNewReview,
            currentReviewId,
            editReview,
            hasReview,
            onAddReviewBtnClick,
        } = this.props;

        this.setState({ isLoading: true });
        if (currentReviewId) {
            editReview(currentReviewId, { rating: starRating })
                .then(() => {
                    trackAnalyticsEvent({
                        action: hasReview
                            ? APP_RATING_UPDATED
                            : APP_RATING_CREATED,
                        category: APP_REVIEW_EVENT_CATEGORY,
                        label: appName,
                        dimensions: {
                            nameOfButton: 'Star',
                            locationOnPage: 'Top',
                            fieldChanged: hasReview ? 'true' : 'false',
                        },
                        metrics: {
                            searchRank: starRating,
                        },
                    });

                    if (onAddReviewBtnClick) {
                        onAddReviewBtnClick();
                    }
                })
                .finally(() => this.setState({ isLoading: false }));
        } else {
            createNewReview(appId, { rating: starRating })
                .then(() => {
                    trackAnalyticsEvent({
                        action: APP_RATING_CREATED,
                        category: APP_REVIEW_EVENT_CATEGORY,
                        label: appName,
                        dimensions: {
                            nameOfButton: 'Star',
                            locationOnPage: 'Top',
                            fieldChanged: 'false',
                        },
                        metrics: {
                            searchRank: starRating,
                        },
                    });

                    if (onAddReviewBtnClick) {
                        onAddReviewBtnClick();
                    }
                })
                .finally(() => this.setState({ isLoading: false }));
        }
    }

    render() {
        const { appName, currentRating, currentReviewId } = this.props;
        const { isLoading } = this.state;
        let titleText = gettext('Rate your experience with %(appName)s', {
            appName,
        });

        if (isLoading) {
            return (
                <div className="eds-align--center eds-l-mar-vert-16">
                    <ProgressIndicator style="gradient" />
                </div>
            );
        }

        if (currentReviewId) {
            titleText = gettext('Your rating for %(appName)s', { appName });
        }

        return (
            <div className="one-click-rating-wrapper eds-align--center">
                <h2 className="eds-l-mar-bot-4">{titleText}</h2>
                <RatingStars
                    isDisabled={false}
                    isReadOnly={false}
                    onStarClick={this._handleStarClick.bind(this)}
                    rating={currentRating}
                    size="medium"
                />
            </div>
        );
    }
}
